import useSWR, { preload } from 'swr';
import { getAuthenticatedHeaders } from './fetchHeaders';
import useSWRInfinite from 'swr/infinite';
import { logFailedRequestTiming, logRequestTiming } from './insightsHelper';

export const useCalculatorConfig = (engineType) => {
    const startTime = performance.now(); // Start timing
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        `/api/v1/file/calc/${engineType}.xml`,
        contentFetcher,
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                key = key.replace('$inf$', '');
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                key = key.replace('$inf$', '');
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }

        });

    return { data, error, isValidating, isLoading, mutate };
}

const contentFetcher = (url) => {
    return getAuthenticatedHeaders().then((headers) => {
        return fetch(url, { headers })
            .then(response => response.blob())
            .then(blob => blob.text());
    });
}

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};